<template>
  <div class="df-progress por unselect" @mousedown="mousedown" :class="{vertical}" :style="dfStyle">
    <div class="load-line poa l0" :style="loadStyle"></div>
    <div class="value-line poa l0" :style="valueStyle">
      <div class="circle poa" :class="{vertical}" @mousedown.stop="circleDown" :style="circleStyle"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DfProgress",
    computed: {
      dfStyle() {
        let {colors, size, vertical} = this;
        return {
          backgroundColor: colors[2],
          [vertical ? 'width' : 'height']: size + 'px',
          borderRadius: size + 'px',
        };
      },
      loadStyle() {
        let {colors, size, vertical, loadValue} = this;
        return {
          backgroundColor: colors[1],
          borderRadius: size + 'px',
          ...(vertical ? {
            width: '100%',
            height: loadValue + '%',
            bottom: 0,
          } : {
            width: loadValue + '%',
            height: '100%',
            top: 0,
          }),
        };
      },
      valueStyle() {
        let {colors, size, vertical, value, moveStart} = this;
        return {
          backgroundColor: colors[0],
          borderRadius: size + 'px',
          ...(vertical ? {
            width: '100%',
            height: (moveStart === null ? value : moveStart) + '%',
            bottom: 0,
          } : {
            width: (moveStart === null ? value : moveStart) + '%',
            height: '100%',
            top: 0,
          }),
        };
      },
      circleStyle() {
        let {circleSize, circleColor} = this;
        return {
          backgroundColor: circleColor,
          width: circleSize + 'px',
          height: circleSize + 'px',
        };
      },
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      loadValue: {
        type: Number,
        default: 100,
      },
      vertical: {
        type: Boolean,
        default: false,
      },
      colors: {
        type: Array,
        default() {
          return [];
        },
      },
      circleSize: {
        type: String | Number,
        default: 10,
      },
      size: {
        type: String | Number,
        default: 4,
      },
      circleColor: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        total: 0,
        left: 0,
        moveStart: null,
      };
    },
    mounted() {
      let {vertical} = this;
      let rect = this.$el.getBoundingClientRect();
      this.$nextTick(() => {
        this.total = rect[vertical ? 'height' : 'width'];
        this.left = rect[vertical ? 'bottom' : 'left'];
      });
    },
    methods: {
      mousedown(e) {
        let {vertical, left, total} = this;
        let curr = e[vertical ? 'offsetY' : 'offsetX'];

        if (vertical) {
          let {height} = e.target.getBoundingClientRect();
          curr = height - curr;
        }
        this.setProgress(curr / total * 100);
      },
      docMove(e) {
        let {vertical, total} = this;
        let curr = e[vertical ? 'movementY' : 'movementX'];
        if (vertical) {
          this.moveStart -= curr / total * 100;
        } else {
          this.moveStart += curr / total * 100;
        }
        if(this.moveStart > 100){
          this.moveStart = 100;
        } else if(this.moveStart <= 0){
          this.moveStart = 0;
        }
        this.$emit('move', this.moveStart);
      },
      docRemove(e) {
        this.setProgress(this.moveStart);
        this.moveStart = null;
        document.removeEventListener('mousemove', this.docMove);
        document.removeEventListener('mouseup', this.docRemove);
        document.removeEventListener('mouseleave', this.docRemove);
      },
      circleDown(e) {
        this.moveStart = this.value;
        document.addEventListener('mousemove', this.docMove);
        document.addEventListener('mouseup', this.docRemove);
        document.addEventListener('mouseleave', this.docRemove);
      },
      setProgress(val) {
        val = Math.round(val);
        val = val > 100 ? 100 : val < 0 ? 0 : val;
        this.value = val;
        this.$emit('input', val);
        this.$emit('change', val);
      },
    }
  }
</script>

<style scoped lang="less">
  .df-progress {
    background-color: rgba(229, 230, 232, .4);
    &.vertical {
      /*transform: rotateX(180deg);*/
    }
  }

  .load-line {
    min-width: 0;
    max-width: 100%;
    min-height: 0;
    max-height: 100%;
    background-color: rgba(229, 230, 232, .8);
  }

  .value-line {
    min-width: 0;
    max-width: 100%;
    min-height: 0;
    max-height: 100%;
    background-color: #1177ff;
  }

  .circle {
    border-radius: 50%;
    background-color: #fff;
    &:not(.vertical) {
      top: 50%;
      right: 0;
      transform: translate(50%, -50%);
    }
    &.vertical {
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

</style>